export interface ScreenComponent<T> {
  id: string;
  name: string;
  type: string;
  props?: T;
  visibility?: ScreenComponentVisibility;
}

export enum ScreenComponentVisibility {
  Always = 'Always',
  InProgress = 'In Progress',
  CompletedStudy = 'Completed Study'
}
